"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OfferCard;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
var _useConfig2 = _interopRequireDefault(require("../hooks/useConfig"));
var _reactRouterDom = require("react-router-dom");
var _LearnMore = _interopRequireDefault(require("./blocks/LearnMore"));
var _DividerBottomSpace = _interopRequireDefault(require("./blocks/DividerBottomSpace"));
var _OfferTitle = _interopRequireDefault(require("./blocks/OfferTitle"));
var _MediaWrapper = _interopRequireDefault(require("./blocks/MediaWrapper"));
var _OfferDescription = _interopRequireDefault(require("./blocks/OfferDescription"));
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _r10CommonComponents = require("r10-common-components");
var _OfferPrice = _interopRequireDefault(require("./blocks/OfferPrice"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable max-len */

// eslint-disable-next-line import/no-unresolved

function OfferCard(_ref) {
  var index = _ref.index,
    campaign = _ref.campaign,
    selectedMsisdn = _ref.selectedMsisdn;
  var t = (0, _useTranslation.default)();
  var history = (0, _reactRouterDom.useHistory)();
  var breakPoint = (0, _r10SourceLibrary.useBreakpoints)();
  var _useConfig = (0, _useConfig2.default)(),
    _useConfig$widgetCust = _useConfig.widgetCustomization,
    _useConfig$widgetCust2 = _useConfig$widgetCust === void 0 ? {} : _useConfig$widgetCust,
    redirectionUrl = _useConfig$widgetCust2.redirectionUrl,
    hidePerMonth = _useConfig$widgetCust2.hidePerMonth,
    fallbackBannerImageUrl = _useConfig$widgetCust2.fallbackBannerImageUrl;
  var offerId = campaign.offerId,
    title = campaign.title,
    shortDescription = campaign.shortDescription,
    price = campaign.price,
    currencyUnit = campaign.currencyUnit,
    catalogPrice = campaign.catalogPrice,
    imageUrl = campaign.imageUrl;
  var perMonthText = !hidePerMonth ? t('per_month') : '';
  var finalPriceProcessed = _r10CommonComponents.utils.formatMoney(price !== null && price !== void 0 ? price : '', currencyUnit !== null && currencyUnit !== void 0 ? currencyUnit : '');
  var catalogPriceProcessed = _r10CommonComponents.utils.formatMoney(catalogPrice !== null && catalogPrice !== void 0 ? catalogPrice : '', currencyUnit !== null && currencyUnit !== void 0 ? currencyUnit : '');
  var finalPriceWithSymbol = "".concat(finalPriceProcessed.money).concat(finalPriceProcessed.currencySymbol);
  var catalogPriceWithSymbol = "".concat(catalogPriceProcessed.money).concat(catalogPriceProcessed.currencySymbol);
  var bannerUrl = imageUrl !== null && imageUrl !== void 0 ? imageUrl : fallbackBannerImageUrl;
  var showCampaign = function showCampaign() {
    history.push("".concat(redirectionUrl, "?msisdn=").concat(selectedMsisdn, "&offerId=").concat(offerId));
  };
  if (!offerId) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Interaction, {
    fullSize: true,
    onClick: showCampaign,
    dataAttributes: {
      'data-testid': "pega-offer-card-".concat(index)
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    elevation: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    layout: {
      sm: [12],
      md: [6, 6]
    },
    spacing: 4,
    verticalAlign: "stretch"
  }, /*#__PURE__*/_react.default.createElement(_MediaWrapper.default, {
    index: index,
    imageUrl: bannerUrl
  }), /*#__PURE__*/_react.default.createElement("div", null, title && /*#__PURE__*/_react.default.createElement(_OfferTitle.default, {
    index: index,
    title: title
  }), shortDescription && /*#__PURE__*/_react.default.createElement(_OfferDescription.default, {
    index: index,
    shortDescription: shortDescription
  }), !(finalPriceProcessed !== null && finalPriceProcessed !== void 0 && finalPriceProcessed.error) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(catalogPriceProcessed !== null && catalogPriceProcessed !== void 0 && catalogPriceProcessed.error) ? /*#__PURE__*/_react.default.createElement(_OfferPrice.default, {
    index: index,
    catalogPriceWithSymbol: catalogPriceWithSymbol,
    finalPriceWithSymbol: finalPriceWithSymbol,
    perMonthText: perMonthText
  }) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3,
    justify: breakPoint.sm ? 'center' : 'left'
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "offer-card-price-".concat(index)
  }, "".concat(finalPriceProcessed.money).concat(finalPriceProcessed.currencySymbol), ' ', perMonthText))), /*#__PURE__*/_react.default.createElement(_DividerBottomSpace.default, {
    space: 4
  }), /*#__PURE__*/_react.default.createElement(_LearnMore.default, {
    index: index
  }))))));
}
OfferCard.propTypes = {
  index: _propTypes.default.number,
  campaign: _propTypes.default.shape({
    offerId: _propTypes.default.string,
    title: _propTypes.default.string,
    shortDescription: _propTypes.default.string,
    price: _propTypes.default.number,
    catalogPrice: _propTypes.default.number,
    currencyUnit: _propTypes.default.string,
    imageUrl: _propTypes.default.string
  }),
  selectedMsisdn: _propTypes.default.string
};